import axios from "axios";
import React, { useState } from "react";
import { Alert, Button, Form, Modal } from "react-bootstrap";
import * as Actions from "../../../constants/baseUrl";
import { toast } from "react-toastify";

const ForgotPasswordPopup = ({ show, onHide }) => {
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    setMessage(null);
    axios
      .post(`${Actions.AUTH_URL}Users/forgot-password`, {
        email: event.target.email.value,
      })
      .then((res) => {
        setLoading(false);
        setMessage(res?.data);
      })
      .catch((error) => {
        toast.error(
          error?.response?.data ||
            "Something went wrong. Please Try again later.",
          {
            autoClose: 3000,
            hideProgressBar: true,
            draggable: true,
          }
        );
        setLoading(false);
      });
  };

  const handleClose = () => {
    setMessage(null);
    onHide();
  };

  return (
    <Modal centered onHide={handleClose} show={show} size="md">
      {loading ? (
        <>
          <span className="register-loader"> </span>
          <span className="spinnerOverlay" />
        </>
      ) : null}

      <Modal.Header closeButton className="py-2">
        <Modal.Title>Forgot Password?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Please enter your email associated with your account to reset your
          password.
        </p>
        <form onSubmit={handleSubmit}>
          <Form.Group className="form-floating mb-3">
            <Form.Control
              type="email"
              id="user-email"
              name="email"
              placeholder="Enter your email"
              required
            />
            <Form.Label htmlFor="user-email">Enter your email</Form.Label>
          </Form.Group>
          {message != null && (
            <Alert className="alert-success small p-2">{message}</Alert>
          )}
          <Button
            className="actionBtnMore ms-auto w-auto d-block"
            type="submit"
          >
            Submit
          </Button>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default ForgotPasswordPopup;
